module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "popup-viewer"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "popup-viewer-mask",
    on: {
      "click": _vm.handleClickOutside
    }
  }, [_c('div', {
    staticClass: "popup-viewer-wrapper"
  }, [_c('div', {
    staticClass: "popup-viewer-container",
    class: {
      'popup-viewer-shake': _vm.isClickingOutside,
      'popup-viewer-container-maximized': _vm.maximized
    }
  }, [_c('div', {
    staticClass: "popup-viewer-header"
  }, [_c('i', {
    staticClass: "fa fa-desktop",
    staticStyle: {
      "margin-left": "5px"
    }
  }), _vm._v(" " + _vm._s(_vm.title) + "\n          "), _c('div', [_c('button', {
    staticClass: "btn popup-viewer-header-button",
    on: {
      "click": _vm.toggleMaximize
    }
  }, [_c('i', {
    class: ("fa fa-window-" + (_vm.maximized ? 'restore' : 'maximize'))
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn popup-viewer-header-button font-bold",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("X")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "popup-viewer-body"
  }, [_c('div', {
    staticClass: "popup-viewer-loading-container"
  }, [_c('div', {
    staticClass: "popup-viewer-loader"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    staticClass: "popup-viewer-body"
  }, [_vm._t("default", function() {
    return [_vm._v("default body")]
  })], 2)])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36f29326","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/_default/components/popup-viewer/PopupViewer.vue
// module id = 1784
// module chunks = 18